import { IntlShape } from 'react-intl';

const SEPARATOR = '|';

const getNavigationLabels = (intl: IntlShape) => {

    return {
        ROOT: intl.formatMessage(
            {
                id: `oe.titles.appTitle`,
                description: 'App title',
                defaultMessage: 'OE Central',
            }
        ),
        BLUEPRINTS: intl.formatMessage(
            {
                id: `oe.titles.blueprintsTitle`,
                description: 'Blueprints title',
                defaultMessage: 'Blueprints',
            }
        ),
        EMAIL_TEMPLATES: intl.formatMessage(
            {
                id: 'oe.titles.emailTemplatesTitle',
                description: 'Email Templates title',
                defaultMessage: 'Email Templates',
            }
        ),
        EVENT_HUBS: intl.formatMessage(
            {
                id: 'oe.titles.eventHubsTitle',
                description: 'Event Hubs title',
                defaultMessage: 'Event Hubs',
            }
        ),
        EVENT_HUB_NAVIGATION: {
            HUB_CONFIGURATION: intl.formatMessage(
                {
                    id: 'oe.titles.eventHubConfigurationTitle',
                    description: 'Event Hub Navigation title',
                    defaultMessage: 'Hub Configuration',
                }
            ),
            ATTENDEES: intl.formatMessage(
                {
                    id: 'oe.titles.eventHubAttendeesTitle',
                    description: 'Event Hub Navigation title',
                    defaultMessage: 'Attendees',
                }
            )
        },
        BLUEPRINTS_NAVIGATION: {
            EVENT_BLUEPRINTS: intl.formatMessage(
                {
                    id: `oe.titles.eventBlueprintsTitle`,
                    description: 'Blueprints Navigation title',
                    defaultMessage: 'Event Blueprints',
                }
            ),

            MEETING_TEMPLATES: intl.formatMessage(
                {
                    id: `oe.titles.meetingTemplatesTitle`,
                    description: 'Meeting Templates Navigation title',
                    defaultMessage: 'Meeting Templates',
                }
            ),

            CONNECTION_TEMPLATES: intl.formatMessage(
                {
                    id: `oe.titles.connectionTemplatesTitle`,
                    description: 'Connection Templates Navigation title',
                    defaultMessage: 'Connection Templates',
                }
            ),

            ORDER_TEMPLATES: intl.formatMessage(
                {
                    id: `oe.titles.orderTemplatesTitle`,
                    description: 'Order Templates Navigation title',
                    defaultMessage: 'Order Templates',
                }
            ),
        },
        ACCOUNTS_LIST: intl.formatMessage(
            {
                id: `oe.titles.accountsTitle`,
                description: 'Accounts title',
                defaultMessage: 'Accounts',
            }
        ),
        ACCOUNT_GROUP_LIST: intl.formatMessage(
            {
                id: `oe.titles.accountGroupsTitle`,
                description: 'Account Groups title',
                defaultMessage: 'Account Groups',
            }
        ),
        RESOURCES_LIST: intl.formatMessage(
            {
                id: `oe.titles.resourcesTitle`,
                description: 'Resources title',
                defaultMessage: 'Resources',
            }
        ),
        OPERATORS_LIST: intl.formatMessage(
            {
                id: `oe.titles.operatorsTitle`,
                description: 'Operators title',
                defaultMessage: 'Operators',
            }
        ),
        USERS_LIST: intl.formatMessage(
            {
                id: `oe.titles.usersTitle`,
                description: 'Users title',
                defaultMessage: 'Users',
            }
        ),
        ROLES_LIST: intl.formatMessage(
            {
                id: `oe.titles.rolesTitle`,
                description: 'Roles title',
                defaultMessage: 'Roles',
            }
        ),
        ACCOUNT_USERS_LIST: intl.formatMessage(
            {
                id: `oe.titles.accountUsersTitle`,
                description: 'Account Users title',
                defaultMessage: 'Account Users',
            }
        ),
        USER_GROUPS_LIST: intl.formatMessage(
            {
                id: `oe.titles.userGroupsTitle`,
                description: 'User Groups title',
                defaultMessage: 'User Groups',
            }
        ),
        ACCOUNT_ADMIN: intl.formatMessage(
            {
                id: `oe.titles.accountAdmin`,
                description: 'Account Admin title',
                defaultMessage: 'Account Admin',
            }
        ),
        THEMES_LIST: intl.formatMessage(
            {
                id: `oe.titles.themesTitle`,
                description: 'Themes title',
                defaultMessage: 'Themes',
            }
        ),
        EVENT_TRACKER_LIST: intl.formatMessage(
            {
                id: 'oe.titles.eventTrackerTitle',
                description: 'Event Tracker title',
                defaultMessage: 'Event Tracker'
            }
        ),
        EVENT_TRACKER_NAVIGATION: {
            UPCOMING: intl.formatMessage(
                {
                    id: 'oe.titles.eventTrackerUpcoming',
                    description: 'Event Tracker upcoming title',
                    defaultMessage: 'Upcoming'
                }
            ),
            PAST: intl.formatMessage(
                {
                    id: 'oe.titles.eventTrackerPast',
                    description: 'Event Tracker past title',
                    defaultMessage: 'Past'
                }
            ),
            DELIVERED: intl.formatMessage(
                {
                    id: 'oe.titles.eventTrackerDelivered',
                    description: 'Event Tracker delivered title',
                    defaultMessage: 'Delivered'
                }
            )
        },
        OE_DATA: intl.formatMessage(
            {
                id: 'oe.titles.oeDataTitle',
                description: 'OE Data title',
                defaultMessage: 'OE Data'
            }
        ),
        OE_DATA_NAVIGATION: {
            ORGANIZATIONS: intl.formatMessage(
                {
                    id: 'oe.titles.oeDataOrganizations',
                    description: 'OE Data organizations tab title',
                    defaultMessage: 'Organizations'
                }
            )
        },
        EVENTS_LIST: intl.formatMessage(
            {
                id: `oe.titles.eventsTitle`,
                description: 'Events title',
                defaultMessage: 'Events',
            }
        ),
        EVENT_NAVIGATION: {
            SCHEDULE: intl.formatMessage(
                {
                    id: `oe.titles.eventNavigation.scheduleTitle`,
                    description: 'Schedule title',
                    defaultMessage: 'Schedule',
                }
            ),
            ORGANIZATIONS: intl.formatMessage(
                {
                    id: `oe.titles.eventNavigation.organizationsTitle`,
                    description: 'Organizations title',
                    defaultMessage: 'Organizations',
                }
            ),
            ATTENDEES: intl.formatMessage(
                {
                    id: `oe.titles.eventNavigation.attendeesTitle`,
                    description: 'Attendees title',
                    defaultMessage: 'Attendees',
                }
            ),
            ROOMS: intl.formatMessage(
                {
                    id: `oe.titles.eventNavigation.roomsTitle`,
                    description: 'Rooms title',
                    defaultMessage: 'Rooms',
                }
            ),
            CONNECTIONS: intl.formatMessage(
                {
                    id: `oe.titles.eventNavigation.connectionsTitle`,
                    description: 'Connections title',
                    defaultMessage: 'Connections',
                }
            ),
            ASSETS: intl.formatMessage(
                {
                    id: 'id.titles.eventNavigation.assetsTitle',
                    description: 'Assets title',
                    defaultMessage: 'Assets'
                }
            ),
            ARTIFACTS: intl.formatMessage(
                {
                    id: 'id.titles.eventNavigation.artifactsTitle',
                    description: 'Artifacts title',
                    defaultMessage: 'Artifacts'
                }
            ),
            PASSPORT: intl.formatMessage(
                {
                    id: `oe.titles.eventNavigation.passportTitle`,
                    description: 'Passport title',
                    defaultMessage: 'Passport',
                }
            ),
            REPORTS: intl.formatMessage(
                {
                    id: `oe.titles.eventNavigation.reportsTitle`,
                    description: 'Reports title',
                    defaultMessage: 'Reports',
                }
            ),
            CONTROL: intl.formatMessage(
                {
                    id: `oe.titles.eventNavigation.controlTitle`,
                    description: 'Control title',
                    defaultMessage: 'Control',
                }
            ),
        },
        ZOOM_NAVIGATION: {
            MEETINGS: intl.formatMessage(
                {
                    id: `oe.titles.zoomNavigation.zoom_meetings`,
                    defaultMessage: 'Meetings',
                    description: 'Label text',
                },
            ),
            USERS: intl.formatMessage(
                {
                    id: `oe.titles.zoomNavigation.zoom_users`,
                    defaultMessage: 'Users',
                    description: 'Label text',
                },
            ),
            TELEPHONES: intl.formatMessage(
                {
                    id: `oe.titles.zoomNavigation.telephone_number_sets`,
                    defaultMessage: 'Telephones Number Sets',
                    description: 'Label text',
                },
            ),
        },
        ATTRIBUTES_NAVIGATION: {
            SETTINGS: intl.formatMessage(
                {
                    id: `oe.titles.attributesNavigation.settingsTitle`,
                    description: 'Settings tab title',
                    defaultMessage: 'Settings',
                }
            ),
            EVENT_ATTRIBUTES: intl.formatMessage(
                {
                    id: `oe.titles.attributesNavigation.eventAttributesTitle`,
                    description: 'Event Attributes tab title',
                    defaultMessage: 'Event Attributes',
                }
            ),
        }
    };
};

export { getNavigationLabels, SEPARATOR };
